import React, {useEffect, useState} from "react";
import {project} from "../../../system/types/project/project";
import {initialProject} from "../../../system/initial/project";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux/reducers";
import {useTranslations} from "../../../hooks/useTranslations";
import Icon from "@mdi/react";
import {mdiChevronRight, mdiHeadQuestionOutline, mdiPencilBoxOutline} from "@mdi/js";
import {dispatch} from "../../../App";
import {actions} from "../../../redux";
import {useNavigate} from "react-router-dom";

import "./ProjectSubMenu.scss";
import {ListProjectKeys} from "./ListProjectKeys";
import {ListProjectLanguages} from "./ListProjectLanguages";
import {ListProjectBackup} from "./ListProjectBackup";

const ProjectSubMenu = () => {

    const { t } = useTranslations();
    const navigate = useNavigate();

    const [projectId, setProjectId] = useState<string>('');
    const [projectData, setProjectData] = useState<project>(initialProject);

    const [showSecondaryMenu, setShowSecondaryMenu] = useState<boolean>(false);

    const [showApiKeys, setShopApiKeys] = useState<boolean>(false);
    const [apiKeysStatus, setApiKeysStatus] = useState<string>('');

    const [showLanguages, setShowLanguages] = useState<boolean>(false);
    const [showLanguagesStatus, setShowLanguagesStatus] = useState<string>('');

    const [showBackup, setShowBackup] = useState<boolean>(false);
    const [showBackupStatus, setShowBackupStatus] = useState<string>('');

    useSelector((state: RootState) => {
        if (state.project.projectId !== projectId) {
            setProjectId(state.project.projectId);
        }
        if (state.project.projectData !== projectData) {
            setProjectData(state.project.projectData);
        }
    });

    const editBaseData = () => {
        dispatch(actions.project.setPageCommand('editBaseData'));
    }

    const startBrainGame = () => {
        navigate('/braingame/' + projectId );
    }

    const toggleShopApiKeys = () => {
        if (!showApiKeys) {
            setShowSecondaryMenu(true);
            setShopApiKeys(true);
            return;
        }

        setShowSecondaryMenu(false);
        setShopApiKeys(false);
    };

    const toggleShopLanguages = () => {
        if (!showLanguages) {
            setShowSecondaryMenu(true);
            setShowLanguages(true);
            return;
        }

        setShowSecondaryMenu(false);
        setShowLanguages(false);
    };

    const toggleShowBackup = () => {
        if (!showBackup) {
            setShowSecondaryMenu(true);
            setShowBackup(true);
            return;
        }

        setShowSecondaryMenu(false);
        setShowBackup(false);
    };

    useEffect(() => {
        if (apiKeysStatus === 'close') {
            setApiKeysStatus('')
            setShowSecondaryMenu(false);
            setShopApiKeys(false);
            return;
        }
    }, [apiKeysStatus]);

    useEffect(() => {
        if (showLanguagesStatus === 'close') {
            setShowLanguagesStatus('')
            setShowSecondaryMenu(false);
            setShowLanguages(false);
            return;
        }
    }, [showLanguagesStatus]);

    useEffect(() => {
        if (showBackupStatus === 'close') {
            setShowBackupStatus('')
            setShowSecondaryMenu(false);
            setShowBackup(false);
            return;
        }
    }, [showBackupStatus]);

    return (
        <div className='projectSubMenu'>
                <div className="row mb-3 mt-3 align-items-center">
                    <div className="col-auto">
                        <button onClick={editBaseData} className="btn  btn-outline-primary"><Icon
                            path={mdiPencilBoxOutline}
                            size={1}/></button>
                    </div>
                    <div className="col-auto">
                        <button onClick={startBrainGame} className="btn  btn-outline-primary"><Icon
                            path={mdiHeadQuestionOutline} size={1}/></button>
                    </div>

                </div>
            {
                showSecondaryMenu ? <>
                    {showApiKeys ? <ListProjectKeys
                        apiKeysStatus={apiKeysStatus}
                        setApiKeysStatus={setApiKeysStatus}
                    ></ListProjectKeys> : null}
                    {showLanguages ? <ListProjectLanguages
                        showLanguagesStatus={showLanguagesStatus}
                        setShowLanguagesStatus={setShowLanguagesStatus}
                    ></ListProjectLanguages> : null}
                    {showBackup ? <ListProjectBackup
                        showBackupStatus={showBackupStatus}
                        setShowBackupStatus={setShowBackupStatus}
                    ></ListProjectBackup> : null}
                </> : (
                    <ul>
                        <li>
                            <span
                                className="link d-inline-flex align-items-center"
                                onClick={toggleShopApiKeys}
                            >{t('projects.apikeys')} <Icon
                                path={mdiChevronRight} size={1}/></span>
                        </li>
                        <li>
                            <span
                                className="link d-inline-flex align-items-center"
                                onClick={toggleShopLanguages}
                            >{t('projects.availablelanguages')}
                                <Icon path={mdiChevronRight} size={1}/></span>
                        </li>
                        <li>
                            <span
                                className="link d-inline-flex align-items-center"
                                onClick={toggleShowBackup}
                            >{t('projects.backup')} <Icon
                                path={mdiChevronRight} size={1}/></span>
                        </li>
                    </ul>
                )
            }
        </div>
    );
}

export {ProjectSubMenu};
